import { useNavigation } from '@react-navigation/core';
import { Button, Headline3, Meta, theme } from 'aimo-ui';
import AccountContext from 'context/AccountContext';
import useDynamicSheetSize from 'hooks/useDynamicSheetSize';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { CenterRow } from 'styles/ContainerStyles';
import { CityParkingNavProps } from 'types/navigation';
import { getCustomerAddress } from 'utils/cityParkingUtils';

const Container = styled.View`
  padding: 0 20px 20px;
  gap: 25px;
`;

const CityParkingHomeAddress = () => {
  const { t } = useTranslation();
  const { customer } = useContext(AccountContext);

  const { handleLayout } = useDynamicSheetSize();
  const { navigate } = useNavigation<CityParkingNavProps>();
  const addressString = getCustomerAddress(customer?.strongAuthentication);

  return (
    <Container onLayout={handleLayout}>
      <CenterRow>
        <Headline3>{t('cityPermits.yourHomeAddress')}</Headline3>
        <Headline3 color={theme.colors.primary}> {addressString}</Headline3>
      </CenterRow>
      <Meta color={theme.colors.gray300}>{t('cityPermits.refetchInfo')}</Meta>
      <Button
        size="l"
        buttonType="tertiary"
        text={t('button.reIdentify')}
        onPress={() => navigate('identification')}
      />
    </Container>
  );
};

export default CityParkingHomeAddress;
